import React, { Fragment, useEffect, useRef, useState, useContext } from "react";
import env from '../../../env';
import useSort from '../../../hooks/useSorting';
import Cs from "../../../services/CommonService";
import { useCurrentUserHook } from "../../Authentication/useUserHook";
import { LinkDeleteIcon } from "../../Common/ImageIcons";
import PaginationSM from '../../Common/PaginationSM';
import SortDirection from '../../Common/SortDirection';
import { Spinner } from "../../Common/Spinner";
import { Table, TBody, TD, TH, THead, TR } from "../../Common/TableView";
import JourneyProfileService from "./JourneyProfileService";
import useModal from "../../../hooks/useModal";
import CommentsModal from "../../Modals/CommentsModal";
import { LinkFontAwesomeIcon } from "../../Common/ImageIcons";
import FormTemplateService from "../../../services/FormTemplateService";
import {OptionsObjList} from '../../Common/FormInput';
import DataSourceService from "../../../services/DataSourceService";
import GenericModal from "../../Modals/GenericModal";
import JourneyProfileCard from './JourneyProfileCard';
import JourneyProfileForm from "./JourneyProfileForm";
import ConfirmMenu from "../../Modals/ConfirmMenu";
import DynamicTable from '../../Common/DynamicTable';
import { NavIcon } from '../../Common/MenuItem';
import { usePageTitle } from "../../../hooks/pageHead";
import { JourneyContext } from './JourneyContext';
import { CacheContext } from "../../../contexts/Cache/CacheStateProvider";
import JourneyTable from './JourneyTable';
import { useSubscriptionAccess } from '../../Subscriptions/useSubscription';
import { DataSourceMenu } from "../../Modals/DataSourceMenu";

const JourneyProfileListTable = (props) => {
  usePageTitle('Journey List');

  const params = props.match.params;
  
  let { current: scope } = useRef({ requestParams: {} });
  const { currentUser, getJourneyMenuId } = useCurrentUserHook();
  const [loading, setLoading] = useState(true);
  const [list, setList] = useState([]);
  const [formFields, setFormFields] = useState([]);
  const [dataSource, setDataSources] = useState({});
  const [filter, setFilter] = useState({});

  const {cacheState, cacheDispatch} = useContext(CacheContext);
  let {journeyState:{journeyList, pagemeta}, journeyDispatch} = useContext(JourneyContext);

  const {isOpen:isJourneyMenuOpen, toggleModal:toggleJourneyMenu} = useModal();
  const {isOpen:isCommentOpen, toggleModal:toggleCommentModal} = useModal();
  const {isOpen:isCardOpen, toggleModal:toggleCardModal} = useModal();
  const {isOpen:isFormOpen, toggleModal:toggleFormModal} = useModal();
  const {isOpen:isDeleteOpen, toggleModal:toggleDeleteModal} = useModal();
  
  useEffect(() => {
    setParams(1);
    getAll();
  }, [props.searchString, filter])

  useEffect(() => {
    getFormFields();
    getDsLocale();
  }, [])

  const setParams = (page) => {
    scope.requestParams = {
      'page': page,
      'paginate': 1,
      'per_page': 15,
      'sort_column': scope.requestParams.sort_column || 'updated_at',
      'sort_direction': scope.requestParams.sort_direction || 'desc',
      'search': props.searchString,
      'filter': filter,
      'organization_id':currentUser.current_organization_id,
    }
  }

  const onPageChage = (page) => {
    setParams(page);
    getAll();
  }

  const getAll = async (dispatchType='REPLACE') => {
    setLoading(true);
    const { status, data } = await JourneyProfileService.getAll(scope.requestParams);
    if (status == 200) {
      journeyDispatch({
        'type': dispatchType,
        'payload': {
          'journeyList': data.journey_profiles,
          'pagemeta': data.meta,
        }
      })
      setLoading(false);
    }
  }

  const { sort } = useSort(scope.requestParams, getAll);

  let getFormFields = () => { 
    FormTemplateService.getFormFields({
      'ids':[1] 
    }).then((res)=>{
      if(res.status === 200){
        setFormFields(res.data.form_fields[1]);
        setLoading(false);
      }
    })
  }

  const getDsLocale = async () =>{
    setLoading(true);
    const data = await DataSourceService.getDataSource({
      'data_source_params':{
        'data_source_id':[3886, 4775],
        'locale':currentUser.current_locale
      }
    })

    if(data){
      setDataSources(data);
      setLoading(false);
    }
  }

  const deleteJourneyProfile = async () => {
    setLoading(true);
    const { status } = await JourneyProfileService.delete(scope.selectedJourneyProfile.id);
    if (status === 204) {
      journeyDispatch({
        'type':"DELETE",
        'id':scope.selectedJourneyProfile.id
      })
    }
  
    setLoading(false);
    toggleDeleteModal();
  }
  
  const onDelete = (journeyProfile) => {
    scope.selectedJourneyProfile = journeyProfile;
    toggleDeleteModal();
  }
  
  const addComments = (journeyProfile) => {
    scope.selectedJourneyProfile = journeyProfile;
    toggleCommentModal();
  }

  const updateStatus = async (idx, journeyProfile) => {
    setLoading(true);
    const { status } = await JourneyProfileService.update(journeyProfile);
    if (status === 204) {
      list[idx].status = journeyProfile.status;
      setList([...list]);
    }
    setLoading(false);
  }

  const update = async (idx, req, callbackFn) =>{
    const { status } = await JourneyProfileService.update(req);
    if(status === 204){
      journeyDispatch({
        'type':"UPDATE",
        'idx':idx,
        'payload':req
      })
      callbackFn && callbackFn(req);
    }
  }

  const openJourneyProfileCard = (journeyProfile) =>{
    scope.selectedJourneyProfile = journeyProfile;
    toggleCardModal();
  }

  const onJourneyMenuSelect = (ds) =>{
    openJourneyProfileFormModal(null, ds);
    toggleJourneyMenu();
    //journeyDispatch({'type': "CLEAR"});
  }
  
  const openJourneyProfileFormModal = (journeyProfile, ds) => {
    scope.journeyProfileFormProps = {
      'match':{
        'params':{
          'id': journeyProfile?.id,
          'form_id':ds?.form_id || journeyProfile?.form_id,
          'journey_type':ds?.sid,
          'form_dsl_id':ds?.pk_id
        }
      },
      'isPopupMode':true,
      'editjourneyProfile':journeyProfile,
      'onSubmit':onSubmit
    }
    toggleFormModal();
  }

  const onSubmit = (journeyProfile) =>{
    const filteredList = list.filter(n => n.id !== journeyProfile.id);
    if(journeyProfile){
      journeyDispatch({
        'type': 'ADD',
        'payload': {
          'newJourney': journeyProfile
        }
      })
    }
  }

  const SortDirIco = ({ column }) => {
    return (
      <SortDirection sortColumn={scope.requestParams.sort_column}
      column={column} reverse={scope.requestParams.reverse} />
    )
  }

  const StatuDropDown = ({id, status, index}) => (
    <select className="form-control input-sm fw500 w-200" 
      onChange={(e)=>updateStatus(index, {'id':id, 'status':e.target.value})} 
      placeholder="Status" defaultValue={status}>
        <option value="">None</option>
        <OptionsObjList list={dataSource.status?.options} 
        idKey='sid' labelKey='label' userLocale={currentUser.current_locale}/>
    </select>
  )

  const journeyProps = {
    journeyList,
    openJourneyProfileFormModal, 
    addComments, 
    onDelete
  }

  return (
    <div id="ct">
        <div className="app-content">
          <div className="app-header flex justspacebetween m-t-15">
            <div className="flex coldir">
              <div className="app-title m-r-20">JourneyProfile Requests</div>
              <div className="font-15 m-t-2">
                Total - {pagemeta.total} | Page - {pagemeta?.current_page}/{pagemeta?.last_page}
              </div>
            </div>
            <div className="flex aligncenter">
              <NavIcon id="new_action" dataTip="Create New Event" 
                className="bg-highlight round-btn m-r-5" 
                icon="fas fa-plus"
                onSelect={()=>toggleJourneyMenu()}/>
            </div>
          </div>

          {loading ? <Spinner /> : null}

          <div className="app-content-section m-t-30 table-fix-head">
            <JourneyTable {...journeyProps}/>  
          </div>

          <PaginationSM
            className="pagination-bar"
            currentPage={parseInt(pagemeta.current_page)}
            totalItems={pagemeta.total}
            itemsPerPage={pagemeta.per_page}
            onPageChange={onPageChage}
            siblingCount={2} />
        </div>

        {isCommentOpen && 
          <CommentsModal 
            isOpen={isCommentOpen} 
            toggleModal={toggleCommentModal} 
            item={scope.selectedJourneyProfile} 
            type="journey_profile"/>
        }

        {isCardOpen &&
          <GenericModal
            component={JourneyProfileCard}
            isOpen={isCardOpen}
            toggleModal={toggleCardModal}
            journeyProfile={scope.selectedJourneyProfile}
            formFields={formFields}
            addComments={addComments}
            onDelete={onDelete}
            currentUser={currentUser}/>
        }

        {isFormOpen && 
          <GenericModal 
            component={JourneyProfileForm}
            isOpen={isFormOpen} 
            toggleModal={toggleFormModal} 
            {...scope.journeyProfileFormProps}/>
        }

        {isJourneyMenuOpen && 
          <DataSourceMenu 
            title="Create new journey workflow"
            toggleModal={toggleJourneyMenu} 
            id={getJourneyMenuId()}
            onSelect={onJourneyMenuSelect}/>
        }

        <ConfirmMenu isOpen={isDeleteOpen} 
          toggleModal={toggleDeleteModal} 
          success={() => deleteJourneyProfile(scope.selectedJourneyProfile)}/>

      </div>
  )

}

export default JourneyProfileListTable;